import nodeApi from '../utils/nodeApiClient';

const taxApi = {
  list: (params) => nodeApi.get('/tax', { params }),
  create: (data) => nodeApi.post('/tax', data),
  update: (id, data) => nodeApi.put(`/tax/${id}`, data),
  remove: (id) => nodeApi.delete(`/tax/${id}`),
  toggleStatus: (id) => nodeApi.patch(`/tax/${id}/status`)
};

export default taxApi;
